import authRequest from '../authRequest';

export default async function uploadDocuments(sessionUuid, documentFiles) {
  if (!sessionUuid || !documentFiles) {
    throw new Error('sessionUuid and documentFiles are required');
  }
  
  const formData = new FormData();
  
  // Handle both single file and array of files
  const files = Array.isArray(documentFiles) ? documentFiles : [documentFiles];
  
  files.forEach((file, index) => {
    console.log(`Uploading file ${index + 1}:`, {
      name: file.name,
      type: file.type,
      size: file.size,
      lastModified: file.lastModified
    });
    formData.append('session[files][]', file);
  });

  try {
    const response = await authRequest(`/sessions/${sessionUuid}/upload_documents`, {
      method: 'POST',
      data: formData,
      // Let the browser set the Content-Type header automatically for FormData
      // This ensures the boundary is set correctly
    });
    console.log('Upload successful:', response);
    return response;
  } catch (error) {
    console.error('Upload failed:', error);
    throw error;
  }
} 